<template>
  <div>
    <el-dialog
      title="选择标签"
      :visible.sync="show"
      append-to-body
      :before-close="closeModal"
      width="730px"
      @close="closeModal"
    >
      <div>
        <div style="display: flex; flex-wrap: wrap; width: 100%">
          <span style="height: 24px; margin: 3px">标签:</span>
          <div style="width: calc(100% - 40px)" id="div-resize">
            <el-tag
              v-for="item in selectedFirstTag"
              :key="item.id"
              closable
              @close="removeTag(item)"
              style="margin: 3px"
              size="small"
              >{{ item.name }}
            </el-tag>
            <!-- <el-tag
              v-for="item in selectedSecondTag"
              :key="item.id"
              closable
              @close="removeTag(item)"
              style="margin: 3px"
              >{{ item.name }}
            </el-tag>

            <el-tag
              v-for="item in selectedThirdTag"
              closable
              :key="item.id"
              @close="removeTag(item)"
              style="margin: 3px"
              >{{ item.name }}
            </el-tag> -->
          </div>
        </div>

        <div
          :style="{
            height: screen_height * 0.95 - 300 - tagHeight + 'px',
            overflow: 'auto',
          }"
        >
          <!-- 一级标签 -->
          <div class="tag-wrap" id="firstTag" v-if="showFirst">
            <div style="margin-bottom: 3px">
              <el-input
                v-model="firstParams.name"
                @keyup.enter.native="getFirst()"
                type="text"
                placeholder="标签名称"
                style="width: 300px; margin-right: 10px"
                size="mini"
              ></el-input
              ><el-button size="mini" @click="getFirst()">搜索</el-button
              ><el-button size="mini" @click="getFirst('reset')">重置</el-button
              ><el-button
                size="mini"
                @click="createTag(3, 0)"
                v-if="power['添加']"
                >新建</el-button
              >
            </div>
            <div style="margin-top: 5px">
              <span style="color: gray">请选择</span>
            </div>
            <div>
              <div>
                <b-form-checkbox-group
                  v-model="selectedFirstTag"
                  @change="selectChange"
                  style="margin-left: -10px; margin-right: -10px"
                >
                  <div
                    class="tag-list"
                    v-for="(item, index) in firstTag"
                    :key="index"
                    :style="setTagStyle(item)"
                  >
                    <b-form-checkbox
                      :value="setValue(item)"
                      style="
                        width: 14px;
                        margin-right: 5px;
                        display: inline-block;
                        margin-left: 5px;
                      "
                    ></b-form-checkbox>
                    <span
                      @click="setParent(item.id, 2, item)"
                      style="width: 90px; font-size: 14px; line-height: 15px"
                      ><span> {{ item.name }}</span>
                    </span>
                  </div>
                </b-form-checkbox-group>
                <div
                  v-loading="showLoading_first"
                  style="width: 100%; height: 50px"
                  element-loading-text="加载中"
                  element-loading-spinner="el-icon-loading"
                  v-if="showLoading_first"
                ></div>
                <div
                  v-if="!firstTag[0] && !showLoading_first"
                  class="no-tag-warning"
                >
                  <div>未搜索到相关标签</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 二级标签 -->
          <div class="tag-wrap" v-if="showSecond">
            <div style="margin-bottom: 3px">
              <el-input
                v-model="secondParams.name"
                @keyup.enter.native="getSecond()"
                type="text"
                placeholder="标签名称"
                style="width: 300px; margin-right: 10px"
                size="mini"
              ></el-input
              ><el-button size="mini" @click="getSecond()">搜索</el-button
              ><el-button size="mini" @click="getSecond('reset')"
                >重置</el-button
              ><el-button size="mini" @click="createTag(3)" v-if="power['添加']"
                >新建</el-button
              >
            </div>
            <div style="margin-top: 5px">
              <span
                style="color: #556ee6; margin-right: 5px; cursor: pointer"
                @click="toFirst"
                >{{ firstItem.name }}</span
              >><span style="margin-left: 5px; color: gray">请选择</span>
            </div>
            <div>
              <div>
                <b-form-checkbox-group
                  v-model="selectedFirstTag"
                  style="margin-left: -10px; margin-right: -10px"
                  @change="selectChange"
                >
                  <div
                    class="tag-list"
                    v-for="(item, index) in secondTag"
                    :key="index"
                    :style="setTagStyle(item)"
                  >
                    <b-form-checkbox
                      :value="setValue(item)"
                      style="
                        width: 14px;
                        margin-right: 5px;
                        display: inline-block;
                        margin-left: 5px;
                      "
                    ></b-form-checkbox>
                    <span
                      @click="setParent(item.id, 3, item)"
                      style="width: 90px; font-size: 14px; line-height: 15px"
                      >{{ item.name }}</span
                    >
                  </div>
                </b-form-checkbox-group>
                <div
                  v-loading="showLoading_second"
                  element-loading-spinner="el-icon-loading"
                  style="width: 100%; height: 50px"
                  element-loading-text="加载中"
                  v-if="showLoading_second"
                ></div>
                <div
                  v-if="!secondTag[0] && !showLoading_second"
                  class="no-tag-warning"
                >
                  <div>未搜索到相关标签</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 三级标签 -->
          <div class="tag-wrap" v-if="showThird">
            <div style="margin-bottom: 3px">
              <el-input
                v-model="thirdParams.name"
                @keyup.enter.native="getThird()"
                type="text"
                placeholder="标签名称"
                style="width: 300px; margin-right: 10px"
                size="mini"
              ></el-input
              ><el-button size="mini" @click="getThird()">搜索</el-button
              ><el-button size="mini" @click="getThird('reset')">重置</el-button
              ><el-button size="mini" @click="createTag(2)" v-if="power['添加']"
                >新建</el-button
              >
            </div>
            <div style="margin-top: 5px">
              <span
                style="color: #556ee6; margin-right: 5px; cursor: pointer"
                @click="toFirst"
                >{{ firstItem.name }}</span
              >>
              <span
                style="
                  color: #556ee6;
                  margin-right: 5px;
                  cursor: pointer;
                  margin-left: 5px;
                "
                @click="toSecond"
                >{{ secondItem.name }}</span
              >><span style="margin-left: 5px; color: gray">请选择</span>
            </div>
            <div>
              <div>
                <b-form-checkbox-group
                  v-model="selectedFirstTag"
                  style="margin-left: -10px; margin-right: -10px"
                  @change="selectChange"
                >
                  <div
                    class="tag-list"
                    v-for="(item, index) in thirdTag"
                    :key="index"
                    :style="setTagStyle(item)"
                  >
                    <b-form-checkbox
                      :value="setValue(item)"
                      style="
                        width: 14px;
                        margin-right: 5px;
                        display: inline-block;
                        margin-left: 5px;
                      "
                    ></b-form-checkbox>
                    <span
                      style="width: 90px; font-size: 14px; line-height: 15px"
                      ><span>{{ item.name }}</span></span
                    >
                  </div>
                </b-form-checkbox-group>
                <div
                  v-loading="showLoading_third"
                  element-loading-spinner="el-icon-loading"
                  style="width: 100%; height: 50px"
                  element-loading-text="加载中"
                  v-if="showLoading_third"
                ></div>
                <div
                  v-if="!thirdTag[0] && !showLoading_third"
                  class="no-tag-warning"
                >
                  <div>未搜索到相关标签</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="closeModal">取消</el-button>
        <el-button size="mini" @click="confirm" type="primary">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="detailTitle"
      :visible.sync="showDetail"
      :before-close="handleClose"
      append-to-body
      width="400px"
    >
      <div
        style="padding: 30px 0px 30px 5px; width: 100%"
        class="flex-align-center"
      >
        <span style="width: 70px">标签名称：</span
        ><el-input
          style="width: 290px"
          v-model="tagName"
          placeholder="请输入"
          size="small"
        ></el-input>
      </div>
      <template slot="footer">
        <el-button @click="handleClose()" size="mini">取消</el-button>
        <el-button @click="save()" type="primary" size="mini">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import tags from "@/server/api/tags";
import Layout from "@/router/layouts/main";

/**
 * Contacts-list component
 */
export default {
  components: {
    Layout,
  },

  data() {
    return {
      power: "",
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      firstParams: {
        page: 1,
        pageSize: 30,
        type: 0, // 0内容标签  1用户标签
        name: "", // 非必需，搜索的时候用
        pid: 0,
      },
      secondParams: {
        page: 1,
        pageSize: 100,
        type: 0, // 0内容标签  1用户标签
        name: "", // 非必需，搜索的时候用
        pid: undefined,
      },
      thirdParams: {
        page: 1,
        pageSize: 100,
        type: 0, // 0内容标签  1用户标签
        name: "", // 非必需，搜索的时候用
        pid: undefined,
      },
      items: [],
      batchs: [
        { text: "批量操作", value: "0" },
        { text: "移除", value: "1" },
      ],
      showDetail: false,
      dialogItem: {},
      detailTitle: "",
      isCreate: false,
      isEdit: false,
      parentLevel: 1,
      isChild: false,
      parentId: 0,
      firstCurrentId: undefined,
      secondCurrentId: undefined,
      secondParent: undefined,
      thirdParent: undefined,
      editRank: 1,
      tagName: "",
      tagId: undefined,
      selectTabs: [],
      firstTag: [],
      secondTag: [],
      thirdTag: [],
      firstItem: {},
      secondItem: {},
      showState: "",
      show: false,
      params: {},
      tags: [],
      selectedFirstTag: [],
      selectedSecondTag: [],
      selectedThirdTag: [],
      tagHeight: 30,
      screen_height: "",
      timer1: 0,
      showFirst: true,
      showSecond: false,
      showThird: false,
      showLoading_first: false,
      showLoading_second: false,
      showLoading_third: false,
    };
  },
  beforeDestroy() {},
  mounted() {
    this.screen_height = window.innerHeight;
    this.getFirst();
    this.power = this.utils.currentPower("智能标签");
    // this.batchs = this.utils.currentBatchs(this.batchs, this.power);
  },

  created() {},
  methods: {
    setValue(item) {
      return {
        id: item.id,
        name: item.name,
      };
    },
    showModel(tags) {
      window.addEventListener("resize", this.throttle1);
      this.show = true;
      let arr = [];
      tags.forEach((item) => {
        let obj = {};
        obj.id = item.id;
        obj.name = item.name;
        arr.push(obj);
      });
      this.selectedFirstTag = arr;
    },
    closeModal() {
      window.removeEventListener("resize", this.throttle1);
      this.show = false;
    },
    confirm() {
      let current = {
        code: "tab",
        tabs: this.selectedFirstTag,
      };
      // console.log(this.selectedFirstTag);
      this.$emit("pageCallback", current);
      this.closeModal();
    },
    //获取一级标签数据
    getFirst(type) {
      if (type == "reset") {
        this.firstParams.name = "";
      }
      this.secondParams.name = "";
      this.thirdParams.name = "";
      this.firstTag = [];
      this.secondTag = [];
      this.thirdTag = [];
      this.firstCurrentId = undefined;
      this.secondParent = undefined;
      this.secondParams.pid = undefined;
      this.showLoading_first = true;
      tags.list(this.firstParams).then((resp) => {
        if (resp.code === 0) {
          this.showLoading_first = false;
          if (resp.data.items && resp.data.items[0]) {
            this.firstTag = resp.data.items;
          }
        } else {
          Vue.swal(resp.msg);
          // console.log(resp);
        }
      });
      // this.firstTag.push({
      //   id: 10000,
      //   name: "长标题标签测试长标题标签测试长标题标签测试长标题标签测试",
      // });
      // this.showLoading_first = false;
      // for (let a = 1; a < 100; a++) {
      //   this.firstTag.push({
      //     id: a,
      //     name: "长标题标签",
      //   });
      // }
    },
    getSecond(type) {
      this.showSecond = true;
      this.showFirst = false;
      this.showThird = false;
      if (type == "reset") {
        this.secondParams.name = "";
      }
      this.thirdParams.name = "";
      if (this.secondParams.pid == undefined) {
        this.secondTag = [];
        return;
      }
      this.secondCurrentId = [];
      this.secondTag = [];
      this.thirdTag = [];
      this.thirdParent = undefined;
      this.thirdParams.pid = undefined;
      this.showLoading_second = true;
      tags.list(this.secondParams).then((resp) => {
        console.log("二级标签", resp);
        if (resp.code === 0) {
          this.showLoading_second = false;
          if (resp.data.items && resp.data.items[0]) {
            this.secondTag = resp.data.items;
          }
        } else {
          Vue.swal(resp.msg);
          console.log(resp);
        }
      });
    },
    getThird(type) {
      this.showThird = true;
      this.showFirst = false;
      this.showSecond = false;
      this.thirdTag = [];
      if (type == "reset") {
        this.thirdParams.name = "";
      }
      if (this.thirdParams.pid == undefined) {
        return;
      }
      this.showLoading_third = true;
      tags.list(this.thirdParams).then((resp) => {
        console.log("三级标签", resp);
        if (resp.code === 0) {
          this.showLoading_third = false;
          if (resp.data.items && resp.data.items[0]) {
            this.thirdTag = resp.data.items;
          }
        } else {
          Vue.swal("数据获取失败");
          console.log(resp);
        }
      });
    },

    handleClose() {
      this.showDetail = false;
    },

    // 编辑
    openDetail(item) {
      if (item) {
        this.dialogItem.id = item.id;
        this.dialogItem.name = item.name;
      } else {
        this.dialogItem = {};
      }
      this.showDetail = true;
    },

    save() {
      if (!this.tagName) {
        Vue.swal("请输入标签名称");
        return;
      }
      let params;
      if (!this.isCreate) {
        params = {
          name: this.tagName,
          id: this.tagId,
        };
        tags.edit(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "编辑成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.handleClose();
            if (this.editRank == 1) {
              this.getFirst();
            } else if (this.editRank == 2) {
              this.getSecond();
            } else {
              this.getThird();
            }
          } else {
            Vue.swal(resp.msg);
          }
        });
      } else {
        params = {
          name: this.tagName,
          parentId: this.parentId,
          parentLevel: this.parentLevel,
        };
        if (this.parentLevel == 3 && this.parentId != 0) {
          params.parentId = this.secondParent;
        } else if (this.parentLevel == 2) {
          params.parentId = this.thirdParent;
        }
        console.log("新建参数", params);
        tags.create(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "添加成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            if (this.editRank == 1) {
              this.getFirst();
            } else if (this.editRank == 2) {
              this.getSecond();
            } else {
              this.getThird();
            }
            this.handleClose();
          } else {
            Vue.swal(resp.msg);
            console.log(resp);
          }
        });
      }
    },

    // 新建
    createTag(level, parentId) {
      this.tagName = "";
      this.parentLevel = level;
      this.isCreate = true;
      if (parentId === 0) {
        this.parentId = 0;
        this.detailTitle = "创建一级标签";
        this.editRank = 1;
      }
      if (level == 3 && parentId === undefined) {
        this.detailTitle = "创建二级标签";
        this.parentId = this.secondParams.pid;
        this.editRank = 2;
      } else if (level == 2) {
        this.detailTitle = "创建三级标签";
        this.editRank = 3;
      }
      this.showDetail = true;
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = [];
          if (item) {
            params.push(item.id);
          } else {
            params = this.choiceListIds;
          }
          tags.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getFirst();
            }
          });
        }
      });
    },

    deleteTag(id, rank) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = [];
          if (typeof id == "number") {
            params.push(id);
          } else if (typeof id == "object") {
            params = id;
          }
          tags.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              if (rank == 1) {
                this.firstCurrentId = undefined;
                this.getFirst();
              } else if (rank == 2) {
                this.secondCurrentId = undefined;
                this.getSecond();
              } else {
                this.getThird();
              }
            }
          });
        }
      });
    },

    editTag(id, name, rank) {
      this.detailTitle = "编辑标签";
      this.isCreate = false;
      this.tagId = id;
      this.tagName = name;
      this.showDetail = true;
      this.editRank = rank;
    },
    setParent(id, rank, item) {
      if (rank == 2) {
        this.firstItem = item;
        this.firstCurrentId = id;
        this.firstTag.forEach((item) => {
          if (item.id == this.firstCurrentId) {
            item.active = true;
          } else {
            item.active = false;
          }
        });
        this.secondParams.pid = id;
        this.secondParent = id;
        this.secondParams.name = "";
        this.getSecond();
      } else if (rank == 3) {
        this.secondItem = item;
        this.secondCurrentId = id;
        this.secondTag.forEach((item) => {
          if (item.id == this.secondCurrentId) {
            item.active = true;
          } else {
            item.active = false;
          }
        });
        this.thirdParams.pid = id;
        this.thirdParent = id;
        this.thirdParams.name = "";
        this.getThird();
      }
    },
    removeTag(item) {
      this.selectedFirstTag.splice(this.selectedFirstTag.indexOf(item), 1);
      this.getTagHeight();
    },
    toFirst() {
      this.showFirst = true;
      this.showSecond = false;
      this.showThird = false;
    },
    toSecond() {
      this.showFirst = false;
      this.showSecond = true;
      this.showThird = false;
    },
    getTagHeight() {
      setTimeout(() => {
        let element = document.getElementById("div-resize");
        if (element) {
          this.tagHeight = Number(
            window.getComputedStyle(element).height.split("px")[0]
          );
          if (!this.tagHeight) {
            this.tagHeight = 30;
          }
        }
      }, 100);
    },
    selectChange() {
      this.getTagHeight();
    },
    throttle1() {
      if (this.timer1) {
        clearTimeout(this.timer1);
      }
      this.timer1 = setTimeout(() => {
        console.log("屏幕高度变化", window.innerHeight);
        this.screen_height = window.innerHeight;
        this.getTagHeight();
      }, 200);
    },
    setTagStyle(item) {
      let obj = {};
      obj.backgroundColor = item.active ? "#d4dbf9" : "#ffffff";
      obj.height = Math.floor((item.name.length - 1) / 6) * 15 + 30 + "px";
      return obj;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tag-list {
  margin: 1px 10px;
  height: 30px;
  border-radius: 3px;
}

.tag-wrap {
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px 10px 5px 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

::v-deep .el-dialog__body {
  padding: 0px 15px 0px;
  background-color: white;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}
::v-deep .el-dialog {
  display: flex !important;
  flex-direction: column !important;
  margin: 0 !important;
  position: relative !important;
  max-height: 95vh !important;
  overflow: hidden;
}
.dialog-common-xb {
  display: flex;
  flex-direction: column;
  max-height: calc(95vh - 141px);
  overflow: hidden;
}
.tag-list {
  // margin: 1px 10px;
  min-height: 30px;
  max-height: 100px;
  border-radius: 3px;
  width: 115px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.no-tag-warning {
  color: gray;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
::v-deep input[type="checkbox"] {
  border-radius: 2px !important;
  margin-top: -3px;
}
// label{
//    border-radius: 3px;
// }
// ::v-deep .custom-control-input{
//   border-radius: 3px !important;
// }
</style>
